"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M8.59 11a4.555 4.555 0 0 1-3.02-1.135C5.222 10.69 5 11.58 5 12.5a.5.5 0 0 1-1 0c0-1.211.334-2.381.839-3.444A4.558 4.558 0 0 1 4 6.409a4.56 4.56 0 0 1 1.345-3.246C7.325 1.183 10.748 0 14.5 0a.503.503 0 0 1 .353.854c-1.021 1.022-1.329 2.888-1.625 4.692-.275 1.673-.535 3.254-1.392 4.11A4.566 4.566 0 0 1 8.59 11ZM6.052 8.948l-.022-.023c1.221-2.182 3.144-3.742 3.564-3.934A.5.5 0 0 0 9.5 4c-.517 0-2.658 1.649-4.111 4.039A3.57 3.57 0 0 1 5 6.409 3.564 3.564 0 0 1 6.052 3.87c1.619-1.62 4.344-2.651 7.423-2.839-.721 1.237-.991 2.873-1.234 4.352l-.001.003c-.247 1.509-.481 2.934-1.11 3.562-1.357 1.356-3.721 1.356-5.078 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.5 24h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1Zm1-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1Zm-4 2h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0 0 1Zm-.004-4.004h4c1.842 0 2.456-3.193 2.66-4.25v-.005c.066-.346.28-.606.45-.764a7.512 7.512 0 0 0 2.39-5.481 7.455 7.455 0 0 0-3.5-6.326.5.5 0 0 0-.535.846 6.46 6.46 0 0 1 3.036 5.48 6.43 6.43 0 0 1-2.073 4.75 2.421 2.421 0 0 0-.75 1.307c-.595 3.108-1.37 3.443-1.678 3.443h-4c-.306 0-1.083-.338-1.68-3.466-.088-.47-.34-.908-.73-1.269a1.543 1.543 0 0 1-.096-.102l-.1-.109a.502.502 0 0 0-.716.7l.07.077.002.002c.052.058.104.115.16.166.16.148.365.393.427.72.202 1.059.817 4.281 2.663 4.281Z"
  })]
});